import {
    TEAM_POST_FAILURE,
    TEAM_POST_REQUEST,
    TEAM_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const postReducer = (state = initialState, action) => {
    const {type, team} = action;
    switch (type) {
        case TEAM_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            team,
        }}

        case TEAM_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case TEAM_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
